/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Intro_Stat_PermissionsInputs */

const es_home_intro_stat_permissions = /** @type {(inputs: Home_Intro_Stat_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`control de permisos por usuario`)
};

const en_home_intro_stat_permissions = /** @type {(inputs: Home_Intro_Stat_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per-user permission control`)
};

/**
* | output |
* | --- |
* | "per-user permission control" |
*
* @param {Home_Intro_Stat_PermissionsInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_intro_stat_permissions = /** @type {((inputs?: Home_Intro_Stat_PermissionsInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Intro_Stat_PermissionsInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_intro_stat_permissions(inputs)
	return en_home_intro_stat_permissions(inputs)
});
export { home_intro_stat_permissions as "home.intro.stat_permissions" }